// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__gvrcy","slider":"styles_slider__WpBuM","button":"styles_button__qxg2q","arrow":"styles_arrow__IF7Sw","arrow--next":"styles_arrow--next__YZsx5"};